(function($){
    $(function(){
    //Video Accessibilty 
        var $videoAcc = $('.zn-video-access');

        if ($videoAcc.length){
            $videoAcc.each(function(idx, itm){
                var vaId = 'zn-va-' + idx,
                    $va = $(itm),
                    $vat = $va.find('.zn-transcript'),
                    $vad = $va.find('.zn-description');

                $va.attr('id', vaId).prepend('<ul class="zn-video-links"></ul>');

                if ($vat.length){
                    $vat.attr('id', vaId + '-transcript');
                    $va.find('.zn-video-links').append('<li><div class="zn-toggle-transcript" aria-expanded="false" aria-controls="' + vaId + '-transcript">Transcript</div></li>');
                }

                if ($vad.length){
                    $vad.attr('id', vaId + '-description');
                    $va.find('.zn-video-links').append('<li><div class="zn-toggle-description" aria-expanded="false" aria-controls="' + vaId + '-description">Description</div></li>');
                }

                var $vaToggle = $va.find('.zn-video-links > li > div'),
                    $vaPanel = $va.children('div');

                $vaToggle.on('click', function(){
                    var $this = $(this),
                        $that = $vaToggle.not($this);

                    if(!$va.hasClass('active')){
                        $va.addClass('active');
                        $this.addClass('active').attr('aria-expanded', 'true');
                        $('#' + $this.attr('aria-controls')).slideDown(400);
                    } else if ($this.hasClass('active')){
                        $va.removeClass('active');
                        $vaToggle.removeClass('active').attr('aria-expanded', 'false');
                        $vaPanel.slideUp(400);
                    } else if ($that.hasClass('active')){
                        $that.removeClass('active').attr('aria-expanded', 'false');
                        $('#' + $that.attr('aria-controls')).slideUp(400);
                        $this.addClass('active').attr('aria-expanded', 'true');
                        $('#' + $this.attr('aria-controls')).slideDown(400);
                    }    
                });

                $vaToggle.addAccess();
            });
        }
    });
})($JQ);